import { PRIMIERA_VALUES, isSettebello } from './cards';

// Compute the primiera score for a set of captured cards.
function primieraScore(cards) {
  const best = { denari: 0, coppe: 0, bastoni: 0, spade: 0 };
  for (const c of cards) {
    const v = PRIMIERA_VALUES[c.value];
    if (v > best[c.suit]) best[c.suit] = v;
  }
  return best.denari + best.coppe + best.bastoni + best.spade;
}

function countDenari(cards) {
  return cards.filter((c) => c.suit === 'denari').length;
}

function hasSettebello(cards) {
  return cards.some(isSettebello);
}

// Computes the points scored in a single hand (mano) for both players.
// scope = { player, cpu } number of scope made this hand.
export function computeHandScore(captured, scope) {
  const p = captured.player;
  const c = captured.cpu;

  const details = {
    player: {
      carte: p.length,
      denari: countDenari(p),
      settebello: hasSettebello(p),
      primiera: primieraScore(p),
      scope: scope.player,
      points: 0,
      won: { carte: false, denari: false, settebello: false, primiera: false },
    },
    cpu: {
      carte: c.length,
      denari: countDenari(c),
      settebello: hasSettebello(c),
      primiera: primieraScore(c),
      scope: scope.cpu,
      points: 0,
      won: { carte: false, denari: false, settebello: false, primiera: false },
    },
  };

  let pPts = scope.player;
  let cPts = scope.cpu;

  // Carte (most cards)
  if (details.player.carte > details.cpu.carte) {
    pPts += 1;
    details.player.won.carte = true;
  } else if (details.cpu.carte > details.player.carte) {
    cPts += 1;
    details.cpu.won.carte = true;
  }

  // Denari (most denari)
  if (details.player.denari > details.cpu.denari) {
    pPts += 1;
    details.player.won.denari = true;
  } else if (details.cpu.denari > details.player.denari) {
    cPts += 1;
    details.cpu.won.denari = true;
  }

  // Settebello
  if (details.player.settebello) {
    pPts += 1;
    details.player.won.settebello = true;
  } else if (details.cpu.settebello) {
    cPts += 1;
    details.cpu.won.settebello = true;
  }

  // Primiera (highest)
  if (details.player.primiera > details.cpu.primiera) {
    pPts += 1;
    details.player.won.primiera = true;
  } else if (details.cpu.primiera > details.player.primiera) {
    cPts += 1;
    details.cpu.won.primiera = true;
  }

  details.player.points = pPts;
  details.cpu.points = cPts;
  return details;
}

// ===== 2-4 players / teams =====
// Same rules as computeHandScore, for any list of sides (players or teams).
// A point (carte, denari, primiera) goes only to a UNIQUE leader; a tie at the
// top awards nobody, exactly like the 1v1 version.
// capturedBySide = { [side]: Card[] }, scopeBySide = { [side]: number }.
export function computeHandScoreSides(capturedBySide, scopeBySide, sides) {
  const details = {};
  for (const s of sides) {
    const cards = capturedBySide[s] || [];
    details[s] = {
      carte: cards.length,
      denari: countDenari(cards),
      settebello: hasSettebello(cards),
      primiera: primieraScore(cards),
      scope: scopeBySide[s] || 0,
      points: scopeBySide[s] || 0,
      won: { carte: false, denari: false, settebello: false, primiera: false },
    };
  }
  for (const key of ['carte', 'denari', 'primiera']) {
    const max = Math.max(...sides.map((s) => details[s][key]));
    const leaders = sides.filter((s) => details[s][key] === max);
    if (leaders.length === 1 && max > 0) {
      details[leaders[0]].won[key] = true;
      details[leaders[0]].points += 1;
    }
  }
  const sb = sides.find((s) => details[s].settebello);
  if (sb) {
    details[sb].won.settebello = true;
    details[sb].points += 1;
  }
  return details;
}
